import { HeaderCard } from 'components/header/headerCard/headerCard.module';
import { HeaderOptions } from 'components/header/headerOptions/headerOptions.module';
import { BOT_MODE, SCREEN_TYPE } from 'consts/enum';
import { setCustomTagHTML } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { chatHeader } from './chatHeader.model';
import { ChatHeaderTemplate } from './chatHeader.template';

export class ChatHeader {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
	}

	initData(props) {
		this.data = { ...chatHeader };
		this.setter(props);
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.className = 'engt-header';
		wrapper.innerHTML = ChatHeaderTemplate(this.data);

		this.html = wrapper;
	}

	initComponents() {
		const headerOptions = new HeaderOptions({ type: SCREEN_TYPE.CHAT }).render();
		const headerCard = new HeaderCard().render();

		if (ENGT_CHAT.get('config.bot_mode') === BOT_MODE.WIDGET) {
			setCustomTagHTML(this.html.querySelector('header-options'), headerOptions);
		}
		setCustomTagHTML(this.html.querySelector('header-card'), headerCard);
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
